export default "__VITE_ASSET__1aa32309__"